/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Responses_Invalid_ValueInputs */

const es_co2_error_responses_invalid_value = /** @type {(inputs: Error_Responses_Invalid_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uno de los valores del formulario no es válido.`)
};

/**

* @param {Error_Responses_Invalid_ValueInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_responses_invalid_value = /** @type {((inputs?: Error_Responses_Invalid_ValueInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Responses_Invalid_ValueInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_responses_invalid_value(inputs)
});